export default __webpack_public_path__ + "static/media/SneakerSwipe2.32221bac.png";